<template>
  <div class="wrap">
    <div class="container">
      <img src="https://kangpingoss.oss-cn-beijing.aliyuncs.com/images/aboutus/introduce.png" width="100%" />
      <img src="https://kangpingoss.oss-cn-beijing.aliyuncs.com/images/aboutus/aboutus.png" style="margin-top: -4px;" width="100%" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    init() {
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding-bottom: 50px;
}
</style>